import { render } from "./EventSection.vue?vue&type=template&id=d6a9913e&scoped=true"
import script from "./EventSection.vue?vue&type=script&lang=js"
export * from "./EventSection.vue?vue&type=script&lang=js"

import "./EventSection.vue?vue&type=style&index=0&id=d6a9913e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a9913e"]])

export default __exports__